import { Injectable } from '@angular/core';
import { SystemButtonDataEntryDto } from '@osos/shared/api';
import { SystemButtonDataPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { SystemButtonParserV1Service } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class SystemButtonDataFactoryService extends FactoryBase<
  SystemButtonDataEntryDto,
  SystemButtonDataPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: SystemButtonParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(
    presenter: SystemButtonDataPresenterModel,
  ): SystemButtonDataEntryDto {
    const parser = this.getParser(
      SystemButtonDataEntryDto,
      SystemButtonDataPresenterModel,
      presenter.specificationVersion,
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: SystemButtonDataEntryDto,
  ): SystemButtonDataPresenterModel {
    const parser = this.getParser(
      SystemButtonDataEntryDto,
      SystemButtonDataPresenterModel,
      model.specificationVersion,
    );

    const result = parser.getPresenterModel(model);
    return result;
  }
}
